export default {
	x: false,
	y: true,
	z: false,
	r: false
};
